const SLICE_NAME = 'experiments';

// METRIC info code the AI sends right after session start.
const EXPERIMENT_ASSIGNED_CODE = 'EXPERIMENT_ASSIGNED';

// The car on the console, the one behind it, and one spare.
const MAX_TRACKED_SESSIONS = 3;

export { SLICE_NAME, EXPERIMENT_ASSIGNED_CODE, MAX_TRACKED_SESSIONS };
